import type { HistoryEventDetail } from '@/components/entity-history/history-detail'
import type { CaseEventDto } from '@/services/api/case-events'

export function historyActor(
  actor: string,
  memberNames: ReadonlyMap<string, string>
): HistoryEventDetail['actor'] {
  return actor === 'system'
    ? { kind: 'system' }
    : { kind: 'user', name: memberNames.get(actor) ?? null }
}

const text = (value: unknown): string | null =>
  typeof value === 'string' && value.trim().length > 0 ? value : null

export function eventDetail(
  event: CaseEventDto,
  context: { uid: string | null; memberNames: ReadonlyMap<string, string> }
): HistoryEventDetail {
  const fromObject = context.uid !== null && event.object_uid === context.uid
  const otherUid = fromObject ? event.subject_uid : event.object_uid
  const otherName = text(fromObject ? event.payload.subject_name : event.payload.object_name)
  const isMerge = event.kind === 'entities_merged' || event.kind === 'merge_reverted'
  return {
    occurredAt: event.occurred_at,
    actor: historyActor(event.actor, context.memberNames),
    auditId: isMerge ? text(event.source_ref.merge_audit_id) : null,
    mentionedAs: event.kind === 'entity_mentioned' ? text(event.payload.name) : null,
    otherEntity: otherUid || otherName ? { uid: otherUid, name: otherName } : null,
    relationship: text(event.payload.type),
    sourceText: text(event.payload.source_text),
  }
}
